import React, { useEffect } from "react";
import { ConfigProvider, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import InsightsReturn from "./InsightsReturn";

import {
  fetchTab1Request,
  fetchTab2Request,
} from "../../store/actions/insight";
import InsightsNewGraph from "./InsightsNewGraph";

const Insights = () => {
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.insight.locations);
  const user = useSelector((state) => state.auth.user);

  const tabItems = [
    {
      key: "1",
      label: "Operations Dashboard",
      children: <InsightsReturn />,
    },
    {
      key: "2",
      label: "Cycle Status Dashboard",
      children: <InsightsNewGraph />,
    },
  ];

  const handleTabChange = (tab) => {
    if (tab === "2") {
      const today = new Date();
      const oneWeekBack = new Date();
      oneWeekBack.setDate(today.getDate() - 7);

      const startDate = `${oneWeekBack.getFullYear()}-${(
        oneWeekBack.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${oneWeekBack
        .getDate()
        .toString()
        .padStart(2, "0")}`;

      const endDate = `${today.getFullYear()}-${(today.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
      console.log("handleTabChange", {
        locations,
        filters: { assettype: "allassets", startDate, endDate },
      });
      dispatch(
        fetchTab2Request({
          locations,
          filters: { assettype: "allassets", startDate, endDate },
        })
      );
    }
  };
  
  useEffect(() => {
    dispatch(fetchTab1Request());
  }, [dispatch, user?.accountId]);

  return (
    <div
      style={{
        minHeight: "65vh",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h2
        style={{ fontWeight: "300", fontSize: "32px", color: "black" }}
        className="font-face-vzw"
      >
        Insights
      </h2>

      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              inkBarColor: "#EE0000",
              itemSelectedColor: "#000000",
              itemHoverColor: "#000000",
              titleFontSize: "24px",
              titleFontSizeLG: "24px",
              titleFontSizeSM: "24px"
            },
          },
        }}
      >
        <Tabs
          defaultActiveKey="1"
          items={tabItems}
          onChange={handleTabChange}
          size="large"
        />
      </ConfigProvider>
    </div>
  );
};

export default Insights;
